
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../Redux/Slices/authslice';
import addDoctor from '../modules/AddDoctor/AddDoctorSlice'
import loadingSlice from '../modules/loading/loadingSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    addDoctor,
    loading: loadingSlice,
  },
});
